import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'

import { LlmTositeLukuToimittajaRekisteritieto, TositteenBusinessIdTyyppi, TositteenMetatiedot, TositteenViitetiedot } from '../../../_jaettu-lemonator/model/llm-tosite-luku-testaus'
import { LlmTositeLukuMetatiedotService } from '../../../_jaettu-lemonator/service/llm-tosite-luku-metatiedot.service'
import { TOIMITTAJA_VALINTA_AUTOMAATTINEN, TOIMITTAJA_VALINTA_EI_REKISTERISSA, toimittajaValintaMetatiedoiksi } from './toimittaja-valinta'

export interface MetatiedotForm {
  toimittaja: FormControl<string>
  businessId: FormControl<string>
  paivamaara: FormControl<string>
  summa: FormControl<number | null>
  toimittajaValinta: FormControl<string>
  /** Tyhjä = tyyppiä ei arvioida. */
  tyyppi: FormControl<string>
}

export const PAIVAMAARA_REGEX = /^\d{4}-\d{2}-\d{2}$/

export function luoMetatiedotFormGroup(): FormGroup<MetatiedotForm> {
  return new FormGroup<MetatiedotForm>({
    toimittaja: new FormControl<string>('', { nonNullable: true }),
    businessId: new FormControl<string>('', { nonNullable: true }),
    paivamaara: new FormControl<string>('', { nonNullable: true }),
    summa: new FormControl<number | null>(null),
    toimittajaValinta: new FormControl<string>(TOIMITTAJA_VALINTA_AUTOMAATTINEN, { nonNullable: true }),
    tyyppi: new FormControl<string>('', { nonNullable: true }),
  })
}

export function lueMetatiedotLomakkeelta(form: FormGroup<MetatiedotForm>): TositteenMetatiedot {
  const arvot = form.getRawValue()
  const summa = arvot.summa === null || arvot.summa === undefined || Number.isNaN(Number(arvot.summa)) ? null : Number(arvot.summa)
  return {
    toimittaja: arvot.toimittaja.trim() || null,
    businessId: arvot.businessId.trim() || null,
    paivamaara: arvot.paivamaara.trim() || null,
    summa,
    ...toimittajaValintaMetatiedoiksi(arvot.toimittajaValinta),
    ...(arvot.tyyppi === 'ostolasku' || arvot.tyyppi === 'kuitti' ? { tyyppi: arvot.tyyppi } : {}),
  }
}

export function asetaViitetiedotLomakkeelle(form: FormGroup<MetatiedotForm>, kentta: 'toimittaja' | 'businessId' | 'paivamaara' | 'summa', viite: TositteenViitetiedot) {
  if (kentta === 'toimittaja') {
    form.controls.toimittaja.setValue(viite.toimittajaNimi ?? '')
  } else if (kentta === 'businessId') {
    form.controls.businessId.setValue(viite.toimittajaTunniste ?? '')
  } else if (kentta === 'paivamaara') {
    form.controls.paivamaara.setValue(viite.paivamaara ?? '')
  } else {
    form.controls.summa.setValue(viite.summa)
  }
  form.markAsDirty()
}

@Component({
  selector: 'app-metatiedot-form',
  templateUrl: './metatiedot-form.component.html',
  styleUrls: ['./metatiedot-form.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MetatiedotFormComponent {
  @Input({ required: true }) form: FormGroup<MetatiedotForm>
  @Input() naytaToimittajaValinta = false
  @Input() toimittajaRekisteri: LlmTositeLukuToimittajaRekisteritieto[] = []
  @Input() businessIdTyhjaHint = ''
  @Input() paivamaaraLabel = 'Päivämäärä (YYYY-MM-DD)'
  @Input() summaLabel = 'Summa'
  @Input() odotettuToimittajaHint: string | null = null

  readonly toimittajaValintaAutomaattinen = TOIMITTAJA_VALINTA_AUTOMAATTINEN
  readonly toimittajaValintaEiRekisterissa = TOIMITTAJA_VALINTA_EI_REKISTERISSA

  constructor(private _metatiedotService: LlmTositeLukuMetatiedotService) {}

  get johdettuTunnusTyyppi(): TositteenBusinessIdTyyppi | null {
    return this._metatiedotService.paatteleBusinessIdType(this.form.controls.businessId.value)
  }
}
